<template >
  <!-- https://vuetifyjs.com/en/components/textareas/ -->
  <v-textarea
    auto-grow
    :label="formDetail.title"
    :variant="formDetail.variant"
    v-model="taValue"
    :name="index"
    :rules="[rulesForm.required, rulesForm.minLength, rulesForm.maxlength]"
  >
  <template v-slot:append-inner>
      <v-tooltip location="bottom" v-if="formDetail.description">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
        {{ formDetail.description }}
      </v-tooltip>
    </template>
  </v-textarea>
</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
const { $form} = useNuxtApp()
const rulesForm = $form.getRules(props.formDetail,props.index);

let taValue = ref(props.model[props.index] ? props.model[props.index] : "");
</script>